import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import React, { DetailedHTMLProps } from 'react';
import { useMediaQuery } from '@material-ui/core';

const useStyles = makeStyles<Theme, { gridTemplateColumns?: string }>((theme: Theme) =>
  createStyles({
    gridLayout: {
      display: 'grid',
      gridTemplateColumns: ({ gridTemplateColumns }) => gridTemplateColumns || '350px 1fr', // left: labels, right: fields
      columnGap: '16px',
      rowGap: '12px',
      alignItems: 'center',
      [theme.breakpoints.down('sm')]: {
        gridTemplateColumns: '1fr',
      },
    },
    mobileLayout: {
      display: 'grid',
      gap: '16px',
    },
  }),
);

export type FormGridProps = {
  gridTemplateColumns?: string;
} & DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

export default function FormGrid(props: FormGridProps) {
  const { gridTemplateColumns, ...rest } = props;
  const classes = useStyles({ gridTemplateColumns });

  const isMobile = useMediaQuery('(max-width: 800px)');

  return <div className={isMobile ? classes.mobileLayout : classes.gridLayout} {...rest} />;
}
